<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>&copy; {{ new Date().getFullYear() }} 
            <a href="https://www.nextorbit.com" target="_blank" rel="nofollow" class="text-black"><img src="@/assets/images/logo/logo-nex.png" alt="logo" class="w-3 ml-1 mr-1"></a>, 
            <!-- <a href="https://www.nextorbit.com" target="_blank" rel="nofollow" class="text-black"><img src="@/assets/images/logo/logo-competti.png" alt="logo" class="w-3 ml-1 mr-1"></a>,  -->
            All rights Reserved
        </span>
        <span class="md:flex hidden items-center">
            <span>Powered by <a href="https://www.nextorbit.com" target="_blank" rel="nofollow" class="text-black"><img src="@/assets/images/logo/logo-full-nex.png" alt="logo" class="w-16 ml-1 mr-10"></a></span>
            <!-- <span>Powered by <a href="https://www.nextorbit.com" target="_blank" rel="nofollow" class="text-black"><img src="@/assets/images/logo/logo-full-competti-big-min.png" alt="logo" class="w-16 ml-1 mr-10"></a></span> -->
            <!-- <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" /> -->
        </span>

        <!-- buyNow component -->
        <!-- <component :is="injections.components.BuyNow"></component> -->
    </footer>
</template>

<script>
// import BuyNow from '../../components/BuyNow.vue'

export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    },
    inject: {
      components:{
          default: {
            // BuyNow
          }
      }
    }
}
</script>
